document.addEventListener('DOMContentLoaded', (event) => {
  const trustedSite = document.querySelector('.trusted_site');
  if (trustedSite) {
    trustedSite.addEventListener('click', function (e) {
      e.preventDefault();
      const trustedImage = document.querySelector('#trustedsite-tm-image');
      if (trustedImage) trustedImage.click();
    });
  }

  // Check for modal and button existence
  function setupModal(modalId, buttonId) {
    const openButton = document.querySelector(buttonId);
    const modal = document.querySelector(`#${modalId}`);
    const overlay = document.querySelector('.modal-overlay');
    const body = document.body;

    if (openButton && modal && overlay) {
      openButton.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.remove('mfp-hide');
        overlay.style.display = 'block';
        body.classList.add('model_open');
      });

      const closeModalButton = modal.querySelector('.closeModal');
      if (closeModalButton) {
        closeModalButton.addEventListener('click', function () {
          closeModal(modal, overlay, body);
        });
      }

      overlay.addEventListener('click', function () {
        closeModal(modal, overlay, body);
      });
    }
  }

  function closeModal(modal, overlay, body) {
    modal.classList.add('mfp-hide');
    overlay.style.display = 'none';
    body.classList.remove('model_open');
  }

  // Safely setup modals
  setupModal('shipping-selector-form', '#shipping-selector-btn');
  setupModal('fitment-form_model', 'a[href="#help-fitment-form"]');

  // Observe cart changes only if the bubble exists
  const cartBubble = document.querySelector('#cart-icon-bubble');
  if (cartBubble) {
    const mutationCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const tabletCount = document.querySelector('.tablet_count');
          if (tabletCount && cartBubble.querySelector('.cart_total')) {
            tabletCount.textContent = cartBubble.querySelector('.cart_total').textContent;
          }
          if(document.querySelector('.total-item') && cartBubble.querySelector('.cart_total')){
            document.querySelector('.total-item').textContent = cartBubble.querySelector('.cart_total').textContent;
          } else {
            document.querySelector('.total-item').textContent = 0;
            document.querySelector('.conitnue-shipping').classList.add("hidden");
            document.querySelector('.c-cart-title').classList.add("hidden");
            document.querySelector('.checkout_wrapper').classList.add("hidden");
            document.querySelector('.c-cart_reccomendated').classList.add("hidden");
            document.querySelector('.c-cart_details').classList.add("hidden");
          }
        }
      }
    };

    const observer = new MutationObserver(mutationCallback);

    const config = {
      childList: true,
      attributes: true,
    };

    observer.observe(cartBubble, config);
  }

  // Account modal handling
  const userAccount = document.querySelector('.userAccount');
  if (userAccount) {
    userAccount.addEventListener('click', function (e) {
      e.preventDefault();
      const userAccountContainer = this.parentElement.querySelector('.user_account-container');
      if (userAccountContainer) {
        userAccountContainer.style.display = 'block';
      }
      e.stopPropagation();
    });
  }

  document.addEventListener('click', function () {
    const popup = document.querySelector('.user_account-container');
    if (popup) {
      popup.style.display = 'none';
    }
  });

  // scroll to review section
  const badge = document.querySelector('.stamped-main-badge');
  const targetSection = document.querySelector('#stamped-main-widget');

  if (badge && targetSection) {
    badge.addEventListener('click', (e) => {
      e.preventDefault();
      targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});

if (document.querySelector('#shipping-selector-btn1')){
  document.querySelector('#shipping-selector-btn1').addEventListener('click',function(){
    document.querySelector('#shipping-selector-btn').click();
  })
}
